let projectId;

/* 异步加载 一些弹窗组件 */
// const TerrainElevationTree = () => import('./terrainElevationTree/TerrainElevationTree');

//按需加载
import { exposureEnvironmentSettings } from "@/components/tables/basicSettings/config/environmentConfig.js";
// import {
// 	EventBus
// } from '../../../static/js/event-bus.js';
let allImageryLayerArr = [];
export default {
  components: {
    // TerrainElevation
  },
  props: {},
  data() {
    return {
      terrainElevation_show: true,

      treeData: [],
      defaultProps: {
        children: "children",
        label: "title",
      },
      checkedIds: [], //页面加载时默认勾选的id
      terrainIds: [], //地形叶节点id，最多只能同时选中一个。地形目录节点不可勾选。
      nowTerrainId: 0,
      isFold: false,

      LoadImageryLayerArr: [], // 已加载的影像图层id数组，用于避免影像图层重复加载。
    };
  },
  mounted() {
    projectId = window.sessionStorage.getItem("nowProjectId");
    this.initTreeData();
  },

  methods: {
    // 初始化列表
    initTreeData() {
      let that = this;

      //对treeData进一步处理，获取到checkedIds和terrainIds
      this.recursionProjectGisInfo2(this.$GLOBAL.terrainElevationTree);
      if (this.nowTerrainId > 0) {
        this.checkedIds.push(this.nowTerrainId);
      }

      this.treeData = this.$GLOBAL.terrainElevationTree;
      //由于地形isDisplay属性为true的数据会不止一条，而地图上实际加载的地形只能是一个，所以这里检查checkedIds里terrainIds的数量，只保留第一个。
      let arrayCommon = this.checkedIds.filter(function (val) {
        return that.terrainIds.indexOf(val) > -1;
      });
      if (arrayCommon.length >= 2) {
        for (let i = arrayCommon.length - 1; i > 0; i--) {
          let tIndex = this.checkedIds.indexOf(arrayCommon[i]);
          if (tIndex !== -1) {
            this.checkedIds.splice(tIndex, 1);
          }
        }
      }
    },
    recursionProjectGisInfo2(data) {
      data?.forEach((item) => {
        if (item.children.length > 0) {
          this.recursionProjectGisInfo2(item.children);
        } else {
          //没有子项时做的操作
          if (!item.gisInfo.type) {
            if (item.gisInfo.gisType === 0) {
              //为影像
              if (item.gisInfo.isDisplay) {
                this.checkedIds.push(item.id);
                this.LoadImageryLayerArr.push(item.id);
              }
              let tempObj = JSON.parse(JSON.stringify(item.gisInfo));
              tempObj.parentId = item.parentId;
              tempObj.tileLayerId = item.tileLayerId;
              allImageryLayerArr.push(tempObj);
            } else if (item.gisInfo.gisType === 1) {
              // 为地形高程
              this.terrainIds.push(item.id);
              if (item.gisInfo.isDisplay) {
                //alert(1)
                //展示数据
                //由于后端返回的地形数据可能不止一条isDisplay属性为true，因此这里不直接写this.checkedIds.push(item.id);以保障数据与显示相符合。
                if (this.nowTerrainId > 0) {
                  //纠正不符合规则的数据。
                  item.gisInfo.isDisplay = false;
                } else {
                  this.nowTerrainId = item.id;
                }
              }
            }
          } else {
            //为目录
          }
        }
      });
      this.$GLOBAL.terrainElevationTree = data;
    },
    handleCheck(data, status) {
      const {
        layerOpacity,
        layerBrightness,
        layerContrast,
        layerHue,
        layerSaturation,
        layerGamma,
        surfaceOpacity,
      } = exposureEnvironmentSettings();
      // 单个树节点的状态变化 只触发一次。
      //修改节点的选中状态时触发。
      if (data && data.children.length < 1) {
        //获取选中节点【不含父节点】
        let checkedArray = this.$refs.terrainElevationTree.getCheckedKeys(true);
        let noChecksArray = this.terrainIds.slice(); //深复制，避免改变原数组。
        let eIndex = noChecksArray.indexOf(data.id);
        let hasDelete = false;
        if (eIndex !== -1) {
          noChecksArray.splice(eIndex, 1);
          for (let i = 0; i < noChecksArray.length; i++) {
            let eCIndex = checkedArray.indexOf(noChecksArray[i]);
            if (eCIndex !== -1) {
              checkedArray.splice(eCIndex, 1);
              hasDelete = true;
            }
          }
        }
        if (hasDelete) {
          checkedArray.push(data.id);
          this.$refs.terrainElevationTree.setCheckedKeys(checkedArray);
        }
      }

      if (data) {
        // 取消选中时不需要考虑影像错误覆盖问题，只有在从未选中状态变为已选中状态时，才需要考虑影像覆盖问题。
        if (status.checkedKeys.includes(data.id)) {
          //找到所有已勾选的影像节点，按照顺序重新加载一遍，避免覆盖。
          // console.log(allImageryLayerArr, this.LoadImageryLayerArr);
          let tempArr = allImageryLayerArr
            .filter((item) => {
              return this.LoadImageryLayerArr.includes(item.id);
            })
            .sort((a, b) => {
              return a.order - b.order;
            });

          // 遍历移除所有已选中的影像图层，然后重新加载一遍，避免影像图层不按顺序加载的问题。在此过程中树结构中节点的勾选状态并没有改变，只是数据中的tileLayerId的要更新一下。
          // console.log("tempArr", status.checkedNodes, tempArr);
          tempArr.map((item) => {
            // this.$GLOBAL.map.removeLayer(item.tileLayerId);
            bimElevationImage.remove(item.id);
          });
          // tempArr.map((item) => {

          // 针对贵州都安高速公路项目 进行影像层级加载优化。 到后面可以让后端给每个影像添加minimumLevel和maximumLevel两个后台配置项，这样就不需要像下面这样写这么多分支代码了。
          // console.log("bimElevationImage1", item);
          // bimElevationImage
          //   .add({
          //     imageXyzId: item.id,
          //     zIndex: item.order,
          //     url,
          //   })
          //   .then((e) => {
          //     this.recursionUpdate(
          //       this.$GLOBAL.terrainElevationTree,
          //       item.tileLayerId,
          //       item.gisType,
          //       true,
          //       e.layer.id
          //     );
          //     allImageryLayerArr = allImageryLayerArr.map((fItem) => {
          //       if (fItem.id === item.id) {
          //         fItem.tileLayerId = e.layer.id;
          //       }
          //       return fItem;
          //     });
          //   });
          // });
          status.checkedNodes.forEach((item) => {
            if (item.gisInfo.gisType == 0 && item.children.length == 0) {
              if (item.gisInfo.type == 0 && item.gisInfo.gisUrl == null) return;
              let url = item.url
                ? item.url
                : this.$GLOBAL.projectBaseUrl +
                  this.$GLOBAL.domBasePort +
                  item.gisInfo.gisUrl;
              bimElevationImage
                .add({
                  imageXyzId: item.id,
                  zIndex: item.order,
                  url,
                  minimumLevel: item.gisInfo.minLevel || 0,
                  maximumLevel: item.gisInfo.maxLevel || 15,
                })
                .then((e) => {
                  this.recursionUpdate(
                    this.$GLOBAL.terrainElevationTree,
                    item.tileLayerId,
                    item.gisInfo.gisType,
                    true,
                    item.id
                  );
                  allImageryLayerArr = allImageryLayerArr.map((fItem) => {
                    if (fItem.id === item.id) {
                      fItem.tileLayerId = e.layer.id;
                    }
                    return fItem;
                  });
                  // console.log("item", this.$GLOBAL.map.getLayers());
                });
            }
          });
        }
      }
    },
    handleCheckChange(data, status) {
      let tileLayerIdx;
      // const {
      //   layerOpacity,
      //   layerBrightness,
      //   layerContrast,
      //   layerHue,
      //   layerSaturation,
      //   layerGamma,
      //   surfaceOpacity,
      // } = exposureEnvironmentSettings();
      if (!status) {
        //取消勾选
        tileLayerIdx = this.$GLOBAL.tileLayerIds.indexOf(data.tileLayerId);
        if (tileLayerIdx >= 0) {
          this.$GLOBAL.tileLayerIds.splice(tileLayerIdx, 1);
        }
      }
      //单个树节点及所有关联改变的树节点的变化 各触发一次。
      if (!data.gisInfo.type) {
        if (data.gisInfo.gisType === 0 && data.gisInfo.gisUrl != null) {
          //为影像
          let url =
            this.$GLOBAL.projectBaseUrl +
            this.$GLOBAL.domBasePort +
            data.gisInfo.gisUrl;
          if (!status) {
            let cancelItem = allImageryLayerArr.filter((item) => {
              return item.id === data.id;
            });
            bimElevationImage.remove(cancelItem[0].id);
            this.recursionUpdate(
              this.$GLOBAL.terrainElevationTree,
              cancelItem[0].tileLayerId,
              data.gisInfo.gisType,
              false,
              data.id
            );

            let fIndex = this.LoadImageryLayerArr.indexOf(data.id);
            if (fIndex !== -1) {
              this.LoadImageryLayerArr.splice(fIndex, 1);
            }
          } else {
            this.LoadImageryLayerArr.push(data.id);
            // allImageryLayerArr = allImageryLayerArr.map((fItem) => {
            //   if (fItem.id === data.id) {
            //     fItem.tileLayerId = e.layer.id;
            //   }
            //   return fItem;
            // });

            // bimElevationImage
            //   .add({
            //     imageXyzId: data.id,
            //     zIndex: data.gisInfo.order,
            //     url,
            //   })
            //   .then((e) => {
            //     tileLayerIdx = this.$GLOBAL.tileLayerIds.indexOf(e.layer.id);
            //     if (tileLayerIdx == -1) {
            //       this.$GLOBAL.tileLayerIds.push(e.layer.id);
            //     }
            //     data.tileLayerId = e.layer.id;
            //     this.recursionUpdate(
            //       this.$GLOBAL.terrainElevationTree,
            //       e.layer.id,
            //       data.gisInfo.gisType,
            //       true
            //     );
            //     allImageryLayerArr = allImageryLayerArr.map((fItem) => {
            //       if (fItem.id === data.id) {
            //         fItem.tileLayerId = e.layer.id;
            //       }
            //       return fItem;
            //     });
            //     this.LoadImageryLayerArr.push(data.id);
            //   });
          }
        } else if (data.gisInfo.gisType === 1 && data.gisInfo.gisUrl != null) {
          //为地形高程
          let url =
            this.$GLOBAL.projectBaseUrl +
            this.$GLOBAL.demBasePort +
            data.gisInfo.gisUrl;
          if (status) {
            //如果勾选了地形则设置地形并加载
            // this.$GLOBAL.map.hasTerrain = true;
            console.log("地形?", this.$GLOBAL.map.terrainProvider);
            bimTerrainProvider.add({
              id: data.id,
              url,
            });

            //this.$GLOBAL.map.terrainProvider返回结果里没有uid，因此这里生成一个随机id，方便和目录树选项对应更新勾选状态。
            let uid = Number(
              Math.random().toString().substr(2, 26) + Date.now()
            ).toString(36);
            data.terrainId = uid;
            this.recursionUpdate(
              this.$GLOBAL.terrainElevationTree,
              data.terrainId,
              data.gisInfo.gisType,
              true
            );
          } else {
            //判断最后选中的节点中是否还有地形节点，没有则取消地形。
            let hasTerrain = false;
            let checkedArray2 =
              this.$refs.terrainElevationTree.getCheckedKeys(true);
            let noChecksArray2 = this.terrainIds.slice(); //深复制，避免改变原数组。
            for (let i = 0; i < noChecksArray2.length; i++) {
              let eCIndex2 = checkedArray2.indexOf(noChecksArray2[i]);
              if (eCIndex2 !== -1) {
                checkedArray2.splice(eCIndex2, 1);
                hasTerrain = true;
                break; //找到一个就可以提前退出了。
              }
            }
            if (!hasTerrain) {
              //关闭地形
              this.$GLOBAL.map.hasTerrain = false;
            }
            this.recursionUpdate(
              this.$GLOBAL.terrainElevationTree,
              data.terrainId,
              data.gisInfo.gisType,
              false
            );
          }
        }
      } else {
        //为目录
      }
    },
    //修改数结构数据里对应项的显示属性,方便用户关闭弹窗再打开后，目录树的勾选状态与上次操作结果一致。
    recursionUpdate(data, id, type, show, newLayerId = "") {
      var that = this;
      data.forEach((item) => {
        if (item.children.length > 0) {
          this.recursionUpdate(item.children, id, type, show, newLayerId);
        } else {
          if (type === 0) {
            //为影像。
            if (item.id === newLayerId) item.gisInfo.isDisplay = show;
            // if (item.tileLayerId && item.tileLayerId === id) {
            //   item.gisInfo.isDisplay = show;
            //   console.log("zhangguan", item.title, item.gisInfo.isDisplay);
            //   if (newLayerId) {
            //     let tileLayerIdx = that.$GLOBAL.tileLayerIds.indexOf(
            //       item.tileLayerId
            //     );
            //     if (tileLayerIdx >= 0) {
            //       that.$GLOBAL.tileLayerIds.splice(tileLayerIdx, 1);
            //     }
            //     item.tileLayerId = newLayerId;
            //     tileLayerIdx = that.$GLOBAL.tileLayerIds.indexOf(
            //       item.tileLayerId
            //     );
            //     if (tileLayerIdx == -1) {
            //       that.$GLOBAL.tileLayerIds.push(item.tileLayerId);
            //     }
            //   }
            // }
          } else if (type === 1) {
            //为地形高程。
            if (item.terrainId && item.terrainId === id) {
              item.gisInfo.isDisplay = show;
            }
          }
        }
      });
      this.$GLOBAL.terrainElevationTree = data;
    },
    terrainElevation_click() {
      this.$emit("terrainElevationBox_close");
    },
  },
  watch: {},
  destroyed() {
    allImageryLayerArr = [];
  },
};
